import React, { Fragment } from 'react';
import { FormBlock } from '../../types/general';
import * as Schema from '../../types/schema';
import Columns from './Columns';
import Accordion from './Accordion';
import Component from './Component';
import Tabs from './Tabs';
import Anchor from './Anchor';

function Row(props: FormBlock<Schema.Row>) {
	const { schema } = props;

	return (
		<Fragment>
			{schema.type === 'columns' && <Columns {...props} />}
			{schema.type === 'accordion' && <Accordion {...props} />}
			{schema.type === 'component' && <Component {...(props as FormBlock<Schema.Component>)} />}
			{schema.type === 'tabs' && <Tabs {...props} />}
			{schema.type === 'anchor' && <Anchor {...props} />}
		</Fragment>
	);
}

export default Row;
